import { Raycaster } from '../../js/three.module.js';
import { GameSceneService } from '../../js/services/game-scene.service.js';

export const getIntersects = (() => {

	var raycaster = new Raycaster();

	return ( position, rotation, far ) => {

		let gameService = GameSceneService.getInstance();

		raycaster.ray.origin.copy( position );
		raycaster.ray.direction.copy( rotation ).normalize( );

		// Oletetaan far numeroksi
		raycaster.far = far || Infinity;
	
		return raycaster.intersectObject( gameService.scene, true );
	};
})();